module.exports = __webpack_public_path__ + "img/edit-icon.a9312a98.svg";